import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GuiFlowService } from '../__gui/gui-flow.service';

@Injectable({
  providedIn: 'root'
})
export class DynamicCrudService {

  currentlyEditing;
  currentStatus;
  loading = false;

  constructor(private http: HttpClient,private guiFlow: GuiFlowService) { }

  validForm(formData){
    for(let obj of formData){
      if(obj.value==null){
        return false;
      }
    }
    return true;
  }

  setCurrentFieldToEdit(columnName){
    this.currentlyEditing = columnName;
  }

  isCurrentFieldEditing(columnName){
    return this.currentlyEditing == columnName;
  }

  getCurrentStatus(){
    return this.currentStatus;
  }

  isCurrentStatus(s){
    return this.currentStatus == s;
  }

  setCurrentStatus(s){
    this.currentStatus = s;
  }

  createObject(data: any,tableName): Observable<any> {
    let url = 'https://voyjaleasdash.ipnetcostarica.com/api-dashboard/post/create.php?table='+tableName
    return this.http.post(url, this.prepareObject(data));
  }

  isLoading(){
    return this.loading;
  }

  setLoading(value){
    this.loading = value;
  }

  
  /* createObjectOld(crudObj,tableName){
    debugger
    this.apiConnector.newDynamicApiRequest('post', tableName, this.prepareObject(crudObj))
    .subscribe(
      (response) => {
        if(response){
          if(response && response.KO){
            this.guiFlow.reportError(response.KO.message,'crud-fields-data.service');
            return false;
          }else{
            this.setCurrentStatus('read');
            return true;
          }
        }else{
          this.guiFlow.reportError('No response received','crud-fields-data.service');
          return false;
        }
      },
      (error) => {
        this.guiFlow.reportError(error,'crud-fields-data.service');
        return false;
      }
    );
  }
 */
  prepareObject(crudObj){
    let postObj = {};
    for(let obj of crudObj){
      postObj[obj['columnName']] = obj.value;
    }
    return postObj;
  }
}
